import { Skeleton, Typography } from '@mui/material'
import { APIError } from 'components/core/errors/api'
import { InsightItem } from 'components/core/insights'
import { TaskValue } from 'lib/actions/task'
import { GetAttributeValueRequest } from 'pbts/c1/api/attribute/v1/attribute'
import { InsightType, RiskInsight } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { attributeGetApi } from 'redux_toolkit/attributes'

type RiskLabelProps = {
    risk: RiskInsight
    task: TaskValue
}

export const ReviewRiskLabel: FC<RiskLabelProps> = ({ risk, task }) => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = attributeGetApi.useGetAttributeValue(GetAttributeValueRequest.create({ id: risk.riskLevelValueId }))
    if (isLoading) {
        return <Skeleton variant="text" />
    }
    if (isError) {
        return <APIError err={error} />
    }
    let reviewRiskMessage = (
        <FormattedMessage
            id="components_insights_risk_certify"
            defaultMessage="This access is {user_risk} risk and this user might be over-permissioned"
            values={{
                user_risk: data?.value?.value.toLowerCase(),
            }}
        />
    )
    if (task?.type?.taskType.oneofKind === 'grant') {
        reviewRiskMessage = (
            <FormattedMessage
                id="components_insights_risk_grant"
                defaultMessage="This access is {user_risk} risk"
                values={{
                    user_risk: data?.value?.value.toLowerCase(),
                }}
            />
        )
    }
    return (
        <Typography>
            {reviewRiskMessage}
        </Typography>
    )
}

const RiskLabel: FC<RiskLabelProps> = ({ risk }) => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = attributeGetApi.useGetAttributeValue(GetAttributeValueRequest.create({ id: risk.riskLevelValueId }))
    if (isLoading) {
        return <Skeleton variant="text" />
    }
    if (isError) {
        return <APIError err={error} />
    }
    return (
        <Typography>
            <FormattedMessage
                id="components_insights_risk"
                defaultMessage="This entitlement is marked as <b>{user_risk}</b> risk"
                values={{
                    b: (chunks) => <b>{chunks}</b>,
                    user_risk: data?.value?.value,
                }}
            />
        </Typography>
    )
}

export type RiskProps = {
    risk: RiskInsight
    insightType: InsightType
    task: TaskValue
}

export const Risk: FC<RiskProps> = ({ risk, insightType, task }) => {
    return (
        <InsightItem key="risk_item" insightType={insightType}>
            <RiskLabel risk={risk} task={task} />
        </InsightItem>
    )
}
